import React from 'react';
import useEffectRange from 'src/hooks/useEffectUtils/useEffectRange';
import { graphqlClient } from 'src/lib/graphql';
import useUserPreferences from 'src/modules/preferences/storage/hook';
import SelectAvailableLanguageDrawer from './SelectAvailableLanguageDrawer';
import LangChangeSuccessDrawer from '../../components/LangChangeSuccessDrawer';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import RequestNewLanguageDrawer from './RequestNewLanguageDrawer';
import useData from './useData';
import RequestNewLangSuccessDrawer from '../../components/RequestNewLangSuccessDrawer';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
const SelectLanguage = ({}) => {
    const [userPrefs, userPrefsActions] = useUserPreferences();
    const [, actions] = useData();
    useEffectRange([1], () => {
        graphqlClient.resetStore();
    }, [userPrefs.lang]);
    const handleDidntFindAnyPress = useCallbackWithCtx(() => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(RequestNewLanguageDrawer, { onItemPress: lang => {
                    actions.requestNewLangAPI.submit(lang.code);
                    bottomDrawerHelperActions.show({
                        component: (React.createElement(RequestNewLangSuccessDrawer, { lang: lang, onDismiss: bottomDrawerHelperActions.hide })),
                    });
                } })),
        });
    }, {});
    return (React.createElement(SelectAvailableLanguageDrawer, { value: userPrefs.lang, onChange: newLang => {
            userPrefsActions.setLang(newLang);
            bottomDrawerHelperActions.show({
                component: (React.createElement(LangChangeSuccessDrawer, { onConfirm: bottomDrawerHelperActions.hide })),
            });
        }, onDidntFindAnyPress: handleDidntFindAnyPress }));
};
export default SelectLanguage;
